/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { AccountInfoStatus, UserPaymentStatus } from "~/constants";
import { AccountInfo } from "~/features/auth/types";

const payoutInfoConfig: {
  check: (reviewStatus: UserPaymentStatus) => boolean;
  status: AccountInfoStatus;
}[] = [
  {
    check: (reviewStatus) => reviewStatus === null || reviewStatus === UserPaymentStatus.NOT_SUBMITTED,
    status: AccountInfoStatus.MISSING,
  },
  {
    check: (reviewStatus) =>
      reviewStatus === UserPaymentStatus.NOT_YET_REVIEWED || reviewStatus === UserPaymentStatus.IN_REVIEW,
    status: AccountInfoStatus.PENDING,
  },
  {
    check: (reviewStatus) =>
      reviewStatus !== UserPaymentStatus.APPROVED_NOT_APPLIED && reviewStatus !== UserPaymentStatus.IN_USE,
    status: AccountInfoStatus.REJECTED,
  },
  {
    check: (reviewStatus) =>
      reviewStatus === UserPaymentStatus.APPROVED_NOT_APPLIED || reviewStatus === UserPaymentStatus.IN_USE,
    status: AccountInfoStatus.APPROVED,
  },
];

const getPayoutInfoStatus: (account: AccountInfo | null) => AccountInfoStatus = (account) => {
  if (!account) {
    return AccountInfoStatus.MISSING;
  }

  const reviewStatus = account.payoutInfo.reviewStatus;

  return payoutInfoConfig.find((row) => row.check(reviewStatus))?.status ?? AccountInfoStatus.MISSING;
};

export default getPayoutInfoStatus;
